import React, { Component } from 'react';
import { isEmpty } from "../Helper/gm";
import getGAevent from "../partners/lib/getGAevent";

class G_B2bTotalCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gnb_menu : this.props.gnb_menu,
    };
  }
  renderGnbList(list, depth, ga_action = ''){
    let show_length = 0;
    if(depth === 1){
      show_length = list.filter( d => d.total_show === false).length;
    }
    return(
      list.map((v, index) => {
        if(!isEmpty(v.total_show) || v.total_show === false)  return "";
        const ga_action_text = isEmpty(ga_action) && depth === 1 ? `Bottom_${v.text}` : ga_action;
        
        return(
          <li key={index} className={`total_ct_dp${depth}`} style={depth === 1 ? {width: (100 / (list.length-show_length))+"%"} : {}} >
            <a
              className="ct_link"
              href={v.link}
              onClick={() => {
                getGAevent({
                  action: ga_action_text,
                  label: depth === 1 ? "index" : v.text
                })
              }}>
              {v.text}
            </a>
            {
              v.level === "admin"? (<span className="b2b_badge_admin">admin</span>): ("")
            }
            {
              v.children.length > 0 ? (
                <ul className="total_ct_list">
                  {
                    this.renderGnbList(v.children, depth+1, ga_action_text)
                  }
                </ul>
              ) : ("")
            }
          </li>
        )
      })
    );
  }
  render() {
    if(isEmpty(this.state.gnb_menu)) return false;
    return(
      <div className="b2b_total_category">
        <ul className="b2b_gnb_wrapper">
          {
            this.renderGnbList(this.state.gnb_menu, 1)
          }
        </ul>
      </div>
    )
  }
}

export default G_B2bTotalCategory;
